import React, { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import File from "./[file]";
import styles from "../../../assets/stylesheets/sass/CustomerFiles.module.scss";
import newstyles from "../../../assets/stylesheets/sass/NewFiles.module.scss";
import style from "../../../assets/stylesheets/sass/UserManagement.module.scss";
import DatepickerUI from "../../customComponents/DatepickerUI";
import download_icon_green from "../../../assets/icons/download_icon_green.svg";
import folder_icon from "../../../assets/icons/folder_iconX.svg";
import admin_settings_black from "../../../assets/icons/admin_settings_black.svg";
import newfolder_icon from "../../../assets/icons/newfolder_iconX.svg";
import download_icon_gray from "../../../assets/icons/download_icon_gray.svg";
import sort_icon_black from "../../../assets/icons/sort_icon_black.svg";
import filter_icon from "../../../assets/icons/filter_icon.svg";
import filter_icon_white from "../../../assets/icons/filter_icon_white.svg";
import arrow_down_black from "../../../assets/icons/arrow_down_black.svg";
import search_icon from "../../../assets/icons/search_icon.svg";
import DatepickerRange from "../../customComponents/DatepickerRange";
import { ReactSession }  from 'react-client-session';
import { getFiles } from "../../../functions/files";
import LoadingStatus from "../../customComponents/LoadingStatus";
import LoadingContainer from "../../customComponents/LoadingContainer";
import localForage from "localforage";
import {getFitDocToken} from "../../../functions/token";
import nofiles_animation from "../../../assets/animations/nofiles_animation.json";
import Lottie from 'react-lottie-player'
import { useSelector } from "react-redux"

import FilterSystem from "../../customComponents/Filter";
import Datepicker from "../../customComponents/Datepicker";
import { subMonths, subWeeks, subYears, setDefaultOptions } from "date-fns";
import { nlBE } from "date-fns/locale";
import { dateToYYYYMMDD } from "../../../functions/conversions";
import { useEffectAllDepsChange } from "../../../hooks/useEffectAllDepsChange";

import { Pagination, Tooltip, useOnClickOutside } from "@qastanfit/qastan-ui";

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker } from 'react-date-range';

import { nl } from "date-fns/locale";
import { handleGetException } from "../../../functions/fetch";
import { getFilesNew } from "../../../functions/filesv2";
import { Input } from "../../ui/input";
import { splitArrayIntoChunks } from "../../../lib/utils";
import { filterObjectsByValue } from "../../../functions/general/filter";

setDefaultOptions({locale: nlBE})

export function Checkbox({label, onChange, color, checked, disabled}){
    const [check, setcheck] = useState(false);

    useEffect(()=>{
        setcheck(checked);
    }, [checked])

    return (
        <label className={style.checkbox_container}>{label}
            <input disabled={disabled ? disabled : false}type="checkbox" defaultChecked={checked} onChange={(e)=>{onChange(e); setcheck(e.currentTarget.checked)}}/>
            <span style={check ? {backgroundColor:color} : {backgroundColor:'#ccc'}} className={style.checkbox_checkmark}></span>
        </label>
    )
}

export default function Files(){
    const navigate = useNavigate();

    const filetypes = useSelector(state => state.filetypes);
    const filetypesTranslations = useSelector(state => state.filetypesTranslations);
    const doctypesTranslations = useSelector(state => state.doctypesTranslations);
    const roles = useSelector(state => state.roles);

    const [content_state, setcontent_state] = useState({});
    const userdata = JSON.parse(window.sessionStorage.getItem("user_data"));

    const [filterSystemData, setfilterSystemData] = useState({});

    const [currentPage, setcurrentPage] = useState(1);
    const [state_files, setstate_files] = useState("loading");
    const [head_files, sethead_files] = useState([]);
    const [view_files, setview_files] = useState([]);
    const [read_files, setread_files] = useState([]);

    const datepickerRef = useRef();
    useOnClickOutside(datepickerRef, ()=>{setshowDatepicker(false)})

    const [disableDatepicker, setdisableDatepicker] = useState(true);
    const [showDatepicker, setshowDatepicker] = useState(false);
    const [selectionRange, setselectionRange] = useState({
        startDate: userdata.role === "1" ? subWeeks(new Date(), 1) : subMonths(new Date(), 6),
        endDate: new Date(),
        key: 'selection',
    });

    const [showAdminSettings, setshowAdminSettings] = useState(false);
    const [exceptionFile, setexceptionFile] = useState([]);
    const [adminsettingsFile, setadminsettingsFile] = useState({});

    const setFilterContent = (content, role) => {
        if(role === "1"){
            //Admin
            setfilterSystemData({
                [content[ReactSession.get("language")] ? (content[ReactSession.get("language")].Files && content[ReactSession.get("language")].Files.filter_filetypes_title && content[ReactSession.get("language")].Files.filter_filetypes_title) : "File types"]: {
                    "type": "multiplechoice",
                    "selector": "dossiertypeid",
                    "options": {
                        [filetypesTranslations.Paardenmest[ReactSession.get("language")]]: "2",
                        [filetypesTranslations.Kippenmest[ReactSession.get("language")]]: "3",
                        [filetypesTranslations.Schuimaarde[ReactSession.get("language")]]: "4",
                        [filetypesTranslations.Stro[ReactSession.get("language")]]: "5",
                        [filetypesTranslations.Gips[ReactSession.get("language")]]: "6",
                        [filetypesTranslations.Substraat[ReactSession.get("language")]]: "7",
                        [filetypesTranslations.Dekaarde[ReactSession.get("language")]]: "8"
                    }
                } ,
                [content[ReactSession.get("language")] ? (content[ReactSession.get("language")].Files && content[ReactSession.get("language")].Files.filter_status_subtitle && content[ReactSession.get("language")].Files.filter_status_subtitle) : "Status"]: {
                    "type": "radiobutton",
                    "selector": "state",
                    "options": {
                        [content[ReactSession.get("language")] ? (content[ReactSession.get("language")].Files && content[ReactSession.get("language")].Files.filter_status_complete && content[ReactSession.get("language")].Files.filter_status_complete) : "CompleteX"]: "4;7;10;13;16;19;22",
                        [content[ReactSession.get("language")] ? (content[ReactSession.get("language")].Files && content[ReactSession.get("language")].Files.filter_status_incomplete && content[ReactSession.get("language")].Files.filter_status_incomplete) : "Incomplete"]: "5;8;11;14;17;20;23"
                    }
                }
            })
        }
        else {
            //User
            setfilterSystemData({
                [content[ReactSession.get("language")] ? (content[ReactSession.get("language")].Files && content[ReactSession.get("language")].Files.filter_filetypes_title && content[ReactSession.get("language")].Files.filter_filetypes_title) : "File types"]: {
                    "type": "multiplechoice",
                    "selector": "dossiertypeid",
                    "options": {
                        [filetypesTranslations.Paardenmest ? filetypesTranslations.Paardenmest[ReactSession.get("language")] : "Paardenmest"]: "2",
                        [filetypesTranslations.Kippenmest ? filetypesTranslations.Kippenmest[ReactSession.get("language")] : "Kippenmest"]: "3",
                        [filetypesTranslations.Schuimaarde ? filetypesTranslations.Schuimaarde[ReactSession.get("language")] : "Schuimaarde"]: "4",
                        [filetypesTranslations.Stro ? filetypesTranslations.Stro[ReactSession.get("language")] : "Stro"]: "5",
                        [filetypesTranslations.Gips ? filetypesTranslations.Gips[ReactSession.get("language")] : "Gips"]: "6",
                        [filetypesTranslations.Substraat ? filetypesTranslations.Substraat[ReactSession.get("language")] : "Substraat"]: "7",
                        [filetypesTranslations.Dekaarde ? filetypesTranslations.Dekaarde[ReactSession.get("language")] : "Dekaarde"]: "8"
                    }
                }
            })
        }
    }

    const getContent = async () => {
        let f = await fetch(process.env.REACT_APP_SERVER_LINK+"content");
        let r = await f.json();
        setcontent_state(r);
    }

    const splitArray = (arr, length) => {
        let result = [];
        let start = 0;
        while (start < arr.length) {
          result.push(arr.slice(start, start + length));
          start += length;
        }
        return result;
    }

    const preDossiers = async () => {
        let files = await localForage.getItem("dossiers")
        if(Array.isArray(files)){
            files.sort((a, b)=>{
                // Convert the creationdate values to Date objects
                const dateA = new Date(a.creationdate);
                const dateB = new Date(b.creationdate);
                // Compare the dates and return 1 if dateA is greater, -1 if dateB is greater, or 0 if they are equal
                if (dateA > dateB) return -1;
                if (dateA < dateB) return 1;
                return 0;
            })
            setstate_files("loaded")
            sethead_files(files);
            setview_files(splitArray(files, 10))
        }
        else {
            console.log(files);
        }
    }

    const getDossiers = async (startDate, endDate) => {
        if(!startDate){
            if(userdata.role === "1"){
                startDate = dateToYYYYMMDD(subWeeks(new Date(), 1))
            }
            else {
                startDate = dateToYYYYMMDD(subMonths(new Date(), 6))
            }  
        }

        if(!endDate){
            endDate = dateToYYYYMMDD(new Date())
        }

        setdisableDatepicker(true);

        let files = await getFilesNew(userdata, startDate, endDate);
        if(Array.isArray(files)){
            localForage.setItem("dossiers", files);
        }

        //let files = await getFiles(userdata, startDate, endDate);
        setdisableDatepicker(false);
        
        if(Array.isArray(files)){
            files.sort((a, b)=>{
                // Convert the creationdate values to Date objects
                const dateA = new Date(a.creationdate);
                const dateB = new Date(b.creationdate);
                // Compare the dates and return 1 if dateA is greater, -1 if dateB is greater, or 0 if they are equal
                if (dateA > dateB) return -1;
                if (dateA < dateB) return 1;
                return 0;
            })
            setstate_files("loaded")
            sethead_files(files);
            setview_files(splitArray(files, 10))
        }
        else {
            console.log("empty")
            setstate_files("empty")
        }
    }

    const handleFilesReadGetAll = async () =>{
        let fr = await localForage.getItem("filesReadAll");
        if(Array.isArray(fr)){
            setread_files(fr);
        }

        let f = await fetch(process.env.REACT_APP_SERVER_LINK+"filesReadGetAll?token="+userdata.token+"&userid="+userdata.id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        });
        
        const r = await f.json();
        if(r.errorcode === 0){
            localForage.setItem("filesReadAll", r.object.files);
            setread_files(r.object.files);
        }
    }

    useEffect(()=>{
        getContent()
        handleFilesReadGetAll()
        preDossiers()
        getDossiers()
    }, [])

    useEffect(()=>{
        setFilterContent(content_state, userdata.role)
    }, [content_state])

    const fullDate = (dateString) => {
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const parts = dateString.split("-");
        const year = parts[0];
        const month = months[parseInt(parts[1]) - 1];
        const day = parseInt(parts[2]);
        return `${day} ${month} ${year}`;
    }

    const addReadFile = async (data) => {
        let fet = await fetch(process.env.REACT_APP_SERVER_LINK+"fileReadUpdate?token="+userdata.token+"&fileid="+data.fileid+"&read="+data.read+"&userid="+userdata.id, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({}),
        })
        let resp = await fet.json();
        if(resp.errorcode === 0){
            handleFilesReadGetAll()
        }
    }

    const openFile = (file) => {
        const name = file.nations[0].description;
        navigate(file.dossierentityid.toString()+"_"+name.replace(/ /g,"_"), {
            file: {id:file.dossierentityid, name:name.replace(/ /g,"_")},
            name: name.replace(/ /g,"_")
        });

        const data = {
            "token": window.localStorage.getItem("token"),
            "read": 1,
            "fileid": file.dossierentityid,
            "userid": userdata.id
        }
        addReadFile(data)
    }

    const sortDate = () => {
        let files = view_files.flat();

        let sortDirection = window.localStorage.getItem("files_sort_date");
        if(!sortDirection){
            sortDirection = "NO";
        }
        if(sortDirection === "NO"){
            sortDirection = "ON"
        }
        else {
            sortDirection = "NO"
        }
        window.localStorage.setItem("files_sort_date", sortDirection)
        
        files.sort((a, b)=>{
            var textA = new Date(a.creationdate);
            var textB = new Date(b.creationdate);
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        })
        if(sortDirection === "ON"){
            setview_files(splitArray(files, 10))
        }
        else {
            setview_files(splitArray(files.reverse(), 10))
        }
    }

    const sortType = () => {
        let files = view_files.flat();

        let sortDirection = window.localStorage.getItem("files_sort_type");
        if(!sortDirection){
            sortDirection = "NO";
        }
        if(sortDirection === "NO"){
            sortDirection = "ON"
        }
        else {
            sortDirection = "NO"
        }
        window.localStorage.setItem("files_sort_type", sortDirection)
        
        files.sort((a, b) => a.dossiertypeid - b.dossiertypeid);

        if(sortDirection === "ON"){
            setview_files(splitArray(files, 10))
        }
        else {
            setview_files(splitArray(files.reverse(), 10))
        }
    }

    const sortName = () => {
        let files = view_files.flat();

        let sortDirection = window.localStorage.getItem("files_sort_name");
        if(!sortDirection){
            sortDirection = "NO";
        }
        if(sortDirection === "NO"){
            sortDirection = "ON"
        }
        else {
            sortDirection = "NO"
        }
        window.localStorage.setItem("files_sort_name", sortDirection)
        
        files.sort((a, b) => a.extendeddescription - b.extendeddescription);

        if(sortDirection === "ON"){
            setview_files(splitArray(files, 10))
        }
        else {
            setview_files(splitArray(files.reverse(), 10))
        }
    }

    const [search_name, setsearch_name] = useState('');

    const searchName = (value) => {
        let v = value.toLowerCase();
        let files = [...head_files].flat();
        
        let filteredArray = files.filter(obj => obj.extendeddescription.toLowerCase().includes(v))

        setview_files(splitArray(filteredArray, 10))
    }

    useEffect(()=>{
        searchName(search_name)
    }, [search_name])

    const convertToDDMMYYYY = (date) => {
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
        var yyyy = date.getFullYear();
      
        return dd + '/' + mm + '/' + yyyy;
    }

    const getFullDoctype = (doctype) =>{
        if(doctypesTranslations && doctype){
            if(doctypesTranslations[doctype]){
                return doctypesTranslations[doctype][ReactSession.get("language")]
            }
            else {
                return doctype;
            }
            
        }   
        return doctype;
    }

    const openRights = async (file) => {
        setadminsettingsFile(file);
        const exception = await handleGetException(userdata, file.dossierentityid, file.dossiertypeid);
        if(exception.errorcode === 0){
            setexceptionFile(exception.object.doctypes)
        }
        setshowAdminSettings(true)
    }
    
    const handleChangeRights = (e) => {
        function convertToInt(arr) {
            return arr.map(function(element) {
              return parseInt(element, 10);
            });
        }

        const fileExceptionAdd = (data) =>{
            fetch(process.env.REACT_APP_SERVER_LINK+"fileExceptionAdd?token="+userdata.token+"&fileid="+data.fileid+"&filetypeid="+data.filetypeid, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data.data),
            })
        }

        const parentId = e.currentTarget.parentNode.parentNode.id.split("_");
        let exception = [...exceptionFile];
        const index = exception.findIndex(exc => exc.doctype.toLowerCase() === parentId[1].toLowerCase())
        if(index > -1){
            let roleClicked = parseFloat(parentId[0])
            let indexUser = convertToInt(exception[index].users).indexOf(parseFloat(roleClicked))
            if(indexUser > -1){
                exception[index].users.splice(indexUser, 1)
            }
            else {
                exception[index].users.push(roleClicked);
            }
            
            const data = {
                "token": userdata.token,
                "fileid": adminsettingsFile.dossierentityid,
                "filetypeid": adminsettingsFile.dossiertypeid,
                "data": {"doctypes": exception}
            }
    
            fileExceptionAdd(data);
        }
    }

    function filterFiles (arr) {
        let tmp = [...arr]
        tmp = filterObjectsByValue(tmp, search_name)
        return tmp;
    }

	return (
	    <>
            {showAdminSettings &&
            <div className={newstyles.adminsettings}>
                <div className={styles.rights_container}>
                    <div className={styles.rights_top}>
                        <p className={style.sub_content_title}>Rechten</p> 
                        <div className={styles.rights_buttons}>
                            <button onClick={()=>{setshowAdminSettings(false)}} className={styles.rights_button_close}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Files && content_state[ReactSession.get("language")].Files.rightspopup_button_close && content_state[ReactSession.get("language")].Files.rightspopup_button_close) : "Close"}</button> 
                        </div>  
                    </div>                    
                <div className={style.roles_legend}>
                    <div style={{backgroundColor:"#4168D3"}} className={style.roles_legend_item}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.roles_recognized_fertilizer && content_state[ReactSession.get("language")].General.roles_recognized_fertilizer) : "Recognized Fertilizer (RF)"}</div>
                    <div style={{backgroundColor:"#D34E4E"}} className={style.roles_legend_item}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.roles_customer && content_state[ReactSession.get("language")].General.roles_customer) : "Customer"}</div>
                    <div style={{backgroundColor:"#0F9B57"}} className={style.roles_legend_item}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.roles_provider && content_state[ReactSession.get("language")].General.roles_provider) : "Provider"}</div>
                </div>  
                <div style={{ marginTop:"3rem", border:"1px solid gainsboro", maxWidth:"calc(100vw - 27rem)", width:"fit-content"}}>      
                    <table className={styles.table} style={{tableLayout:"fixed", width:"unset"}}>
                        <tbody>
                            <tr>
                                <th></th>
                                <th style={{minWidth:"6rem", textAlign:"center"}}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Files && content_state[ReactSession.get("language")].Files.rightspopup_title && content_state[ReactSession.get("language")].Files.rightspopup_title) : "Rights"}</th>
                            </tr>
                            
                            {Array.isArray(exceptionFile) && exceptionFile.map((v, i)=>{
                                return (
                                    <tr key={i}>
                                        <td><div style={{fontWeight:"600"}}>{getFullDoctype(v.doctype)}</div></td>
                                        <td>
                                            <div className={style.checkbox_content}>
                                                {roles.map((val_roles, ind_roles)=>{                                                    

                                                    if(val_roles.id === 4){
                                                        //Aanbieder
                                                        return <div id={val_roles.id+"_"+v.doctype} key={ind_roles} className={style.checkbox_item}><Checkbox checked={v.users.includes(val_roles.id)} color={"#0F9B57"} onChange={(e)=>{handleChangeRights(e)}}/></div>
                                                    }
                                                    else if(val_roles.id === 3){
                                                        //Afnemer
                                                        return <div id={val_roles.id+"_"+v.doctype} key={ind_roles} className={style.checkbox_item}><Checkbox checked={v.users.includes(val_roles.id)} color={"#D34E4E"} onChange={(e)=>{handleChangeRights(e)}}/></div>
                                                    } 
                                                    else if(val_roles.id === 2){
                                                        //EM
                                                        return <div id={val_roles.id+"_"+v.doctype} key={ind_roles} className={style.checkbox_item}><Checkbox checked={v.users.includes(val_roles.id)} color={"#4168D3"} onChange={(e)=>{handleChangeRights(e)}}/></div>
                                                    }                      
                                                })}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                </div>
            </div>
            }

            {disableDatepicker && 
            <div className={newstyles.loading_container}>
                <div className={newstyles.loader}></div>
                <p>Dossiers zoeken...</p>
            </div>
            }

            <p className={styles.title}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Files.title && content_state[ReactSession.get("language")].Files.title) : "Files"}</p>         

            {state_files !== "error" && state_files !== "loading" &&
            <div className={newstyles.top_header}>
                <div>
                    <Input value={search_name} onChange={({currentTarget})=>{setsearch_name(currentTarget.value)}} placeholder={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Files && content_state[ReactSession.get("language")].Files.search_placeholder && content_state[ReactSession.get("language")].Files.search_placeholder) : "Search..."}/>
                    {/* <input onChange={(e)=>{searchName(e.target.value)}} className={newstyles.search_input} type="text" placeholder={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Files && content_state[ReactSession.get("language")].Files.search_placeholder && content_state[ReactSession.get("language")].Files.search_placeholder) : "Search..."}/> */}
                </div>
                <div className={newstyles.top_header_item}>
                    <div className={`${disableDatepicker && newstyles.datepicker_button_disabled} ${newstyles.datepicker_button}`} ref={datepickerRef} onClick={()=>{if(!disableDatepicker){setshowDatepicker(true)}}}>
                        <p>{convertToDDMMYYYY(selectionRange.startDate)} - {convertToDDMMYYYY(selectionRange.endDate)}</p>
                        <div className={newstyles.datepicker} style={(!showDatepicker || disableDatepicker) ? {display:"none"} : {}}>
                            <DateRangePicker
                                months={1}
                                locale={nl}
                                weekStartsOn={1}
                                ranges={[selectionRange]}
                                onChange={(value)=>{getDossiers(dateToYYYYMMDD(value.selection.startDate), dateToYYYYMMDD(value.selection.endDate)); setselectionRange(value.selection)}}
                            />
                        </div>
                    </div>
                    <FilterSystem 
                        placeholder_hide={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Files.filter_producttype_hide && content_state[ReactSession.get("language")].Files.filter_producttype_hide) : "Hide all"}
                        placeholder_show={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Files.filter_status_show) : "Show all"}
                        placeholder={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Files.filter_button && content_state[ReactSession.get("language")].Files.filter_button) : "Filter"} 
                        data={head_files} 
                        system={filterSystemData} 
                        result={(v)=>{setview_files(splitArray(v, 10)); setcurrentPage(1); window.sessionStorage.setItem("page_files", 1)}}
                    />
                </div>
            </div>
            }

            {(head_files && state_files !== "error" && state_files !== "empty") &&
            <>  
                

                <div className={`${userdata.role === "1" && newstyles.admin_file_row} ${newstyles.file_header} ${newstyles.file_row}`}>
                    <i></i>
                    <div className={newstyles.file_header_item}><p>Dossiernaam</p><button className={newstyles.icon_button} onClick={()=>{sortName()}}><img className={newstyles.icon} src={sort_icon_black} alt="sort"/></button></div>
                    <div className={newstyles.file_header_item}><p>Type</p><button className={newstyles.icon_button} onClick={()=>{sortType()}}><img className={newstyles.icon} src={sort_icon_black} alt="sort"/></button></div>
                    <div className={newstyles.file_header_item}><p>Datum</p><button className={newstyles.icon_button} onClick={()=>{sortDate()}}><img className={newstyles.icon} src={sort_icon_black} alt="sort"/></button></div>
                    {userdata.role === "1" && <i></i>}
                </div>
                {splitArrayIntoChunks(filterFiles(head_files), 10)[currentPage - 1] && splitArrayIntoChunks(filterFiles(head_files), 10)[currentPage - 1].map((file, index)=> {
                    return (
                        <div className={`${userdata.role === "1" && newstyles.admin_file_row} ${Array.isArray(read_files) && !read_files.includes(parseFloat(file.dossierentityid)) && newstyles.file_row_new} ${newstyles.file_row}`} key={index}>
                            <span onClick={()=>{openFile(file)}} className={newstyles.icon}><img src={!read_files.includes(parseFloat(file.dossierentityid)) ? newfolder_icon : folder_icon} alt="file"/></span>
                            <div onClick={()=>{openFile(file)}} className={newstyles.file_row_item}><p>{file.extendeddescription}</p></div>
                            <div onClick={()=>{openFile(file)}} className={newstyles.file_row_item}><p>{Array.isArray(filetypes) && filetypes[filetypes.findIndex(filetype => filetype.dossiertypeid === file.dossiertypeid)].name}</p></div>
                            <div onClick={()=>{openFile(file)}} className={newstyles.file_row_item}><p>{fullDate(file.creationdate)}</p></div>
                            {userdata.role === "1" && (<div className={`${newstyles.file_row_admin_actions} ${newstyles.file_row_item}`}>
                                <Tooltip text={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Files.tooltip_rights_file && content_state[ReactSession.get("language")].Files.tooltip_rights_file) : "Open filerights"} position="left">
                                    <button onClick={()=>{openRights(file)}} className={newstyles.filerow_adminsettings_button}><img src={admin_settings_black} alt="admin settings"/></button>
                                </Tooltip>
                                
                            </div>)}
                        </div>
                    )
                })}

                <div className={newstyles.bottom_footer}>                
                    <Pagination direction="top" size="compact" numPages={view_files.length} currentPage={currentPage} onChange={(page)=>{setcurrentPage(parseFloat(page))}}/>
                </div>
            </>
            }

            {(state_files === "empty" || state_files === "error") && (
                <div className={styles.error_container}>
                    <div><Lottie loop animationData={nofiles_animation} play style={{ width: 200, height: 200 }}/></div>
                    <p>Oops!</p>
                    <p>Geen dossiers gevonden</p>
                </div>
            )}

            {state_files === "loading" &&
                <div className={styles.error_container}>
                    <p>Even geduld...</p>
                </div>
            }
	    </>  
  	);
}
 